import { useState } from "react";
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "../../components/ui/tabs";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Card, CardHeader, CardContent } from "../../components/ui/card";
import productimg from "../../product-01-330x440.png";
import productimg1 from "../../product-02-330x440.png";
import productimg2 from "../../product-03-330x440.png";
import { User, ListOrdered, MapPin, Plus } from "lucide-react"; // Lucide icons
import { Label } from "../../components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../../components/ui/dialog";
import Header from "../../components/VibrantSolComponents/Header";
import Footer from "../../components/VibrantSolComponents/Footer";
function OrderPage() {
  const [open, setOpen] = useState(false);

  const addresses = [
    {
      name: "D Sireesha Kumari",
      address:
        "F1, Sai Srinivasa recidency, 2nd floor, Lanco Power Township, Gollapudi",
      city: "VIJAYAWADA",
      state: "ANDHRA PRADESH",
      zip: "521225",
      country: "India",
      phone: "9177967707",
      default: true,
    },
    {
      name: "Boddepalli suresh",
      address: "Plot no 274, ma nagar, near IT junction, Madhurawada, vskp",
      city: "MADHURAWADA",
      state: "ANDHRA PRADESH",
      zip: "530041",
      country: "India",
      phone: "8074680957",
    },
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <nav className="flex justify-center py-4 bg-gray-50">
        <ol className="flex items-center space-x-2">
          <li>
            <span className="text-gray-400 font-medium">Home</span>
          </li>
          <li>
            {/* Separator */}
            <span className="text-gray-300 font-medium">——</span>
          </li>
          <li>
            <span className="text-gray-700 font-medium">My Orders</span>
          </li>
        </ol>
      </nav>
      <div className="max-w-7xl w-full mx-auto py-12 px-4">
        <h1 className="text-3xl md:text-4xl text-center mb-6 secdory-font">
          My Orders
        </h1>
        <Tabs
          defaultValue="orders"
          className="flex flex-col md:flex-row items-start gap-6"
        >
          <TabsList className="flex flex-row md:flex-col w-full md:w-48 bg-white p-0 md:pb-4 rounded-md h-auto">
            <TabsTrigger
              value="orders"
              className="flex items-center gap-2 md:justify-start w-full md:px-5 py-3
           transition data-[state=active]:bg-blue-100 data-[state=active]:text-blue-700"
            >
              <ListOrdered size={18} /> My Orders
            </TabsTrigger>
            <TabsTrigger
              value="profile"
              className="flex items-center gap-2 md:justify-start w-full md:px-5 py-3 
           transition data-[state=active]:bg-blue-100 data-[state=active]:text-blue-700"
            >
              <User size={18} /> My Profile
            </TabsTrigger>

            <TabsTrigger
              value="address"
              className="flex items-center gap-2 md:justify-start w-full md:px-5 py-3
           transition data-[state=active]:bg-blue-100 data-[state=active]:text-blue-700"
            >
              <MapPin size={18} /> My Address
            </TabsTrigger>
          </TabsList>

          <div className="flex-1">
            {/* My Profile */}
            <TabsContent value="profile">
              <Card>
                <CardHeader className="!p-4 !pb-0">
                  <h2 className="text-lg font-semibold">My Profile</h2>
                </CardHeader>
                <CardContent className="!p-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <Label className="block text-sm font-medium mb-1">
                        First Name
                      </Label>
                      <Input value="D Sireesha" readOnly />
                    </div>

                    <div>
                      <Label className="block text-sm font-medium mb-1">
                        Last Name
                      </Label>
                      <Input value="Kumari" readOnly />
                    </div>

                    <div className="md:col-span-2">
                      <Label className="block text-sm font-medium mb-1">
                        Email
                      </Label>
                      <Input value="d.sireesha@email.com" readOnly />
                    </div>

                    <div className="md:col-span-2">
                      <Label className="block text-sm font-medium mb-1">
                        Phone
                      </Label>
                      <Input value="9177967707" readOnly />
                    </div>

                    <div className="md:col-span-2">
                      <Label className="block text-sm font-medium mb-1">
                        Address
                      </Label>
                      <Input
                        value="F1, Sai Srinivasa ... VIJAYAWADA, ANDHRA PRADESH 521225"
                        readOnly
                      />
                    </div>
                    <div className="md:col-span-2 space-x-4 text-center">
                      <Button
                        variant="outline"
                        className="py-3 rounded-md font-semibold mb-4 hover:bg-gray-800 transition"
                      >
                        Cancel
                      </Button>
                      <Button className=" bg-primary text-white py-3 rounded-md font-semibold mb-4 hover:bg-gray-800 transition">
                        Save
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </TabsContent>

            {/* My Orders */}
            <TabsContent value="orders">
              <Card>
                <CardHeader className="!p-4 !pb-0">
                  <h2 className="text-lg font-semibold">My Orders Placed</h2>
                </CardHeader>
                <CardContent className="!p-4">
                  <div className="border mb-3 rounded-lg p-3">
                    <div className="flex items-center justify-between mb-2 mt-7px">
                      <div>
                        <div className="text-xs text-gray-500">
                          ORDER PLACED
                        </div>
                        <div className="text-sm font-bold">26 July 2025</div>
                      </div>
                      <div>
                        <span className="text-xs text-gray-500">TOTAL</span>
                        <div className="text-sm font-bold">₹99.00</div>
                      </div>
                      <div>
                        <span className="text-xs text-gray-500">ORDER #</span>
                        <div className="text-sm font-bold">
                          D01-2064033-3669461
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-4">
                      <img
                        src={productimg1}
                        alt="Ala Vaikunthapurramuloo"
                        className="w-10 rounded bg-gray-100"
                      />
                      <div>
                        <div className="font-medium">
                          Ala Vaikunthapurramuloo
                        </div>
                        <div className="text-xs text-gray-500">Prime Video</div>
                      </div>
                    </div>
                  </div>
                  <div className="border mb-3 rounded-lg p-3">
                    <div className="flex items-center justify-between mb-2 mt-7px">
                      <div>
                        <div className="text-xs text-gray-500">
                          ORDER PLACED
                        </div>
                        <div className="text-sm font-bold">1 July 2025</div>
                      </div>
                      <div>
                        <span className="text-xs text-gray-500">TOTAL</span>
                        <div className="text-sm font-bold">₹693.00</div>
                      </div>
                      <div>
                        <span className="text-xs text-gray-500">ORDER #</span>
                        <div className="text-sm font-bold">
                          407-3577818-2809959
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-4">
                      <img
                        src={productimg}
                        alt="HP Mouse"
                        className="w-10 rounded bg-gray-100"
                      />
                      <div>
                        <div className="font-medium">
                          HP M120 Wireless Mouse USB-A
                        </div>
                        <div className="text-xs text-gray-500">
                          Delivered 3 July
                        </div>
                        <div className="text-xs text-gray-500">
                          Return window closed on 13 July 2025
                        </div>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </TabsContent>

            {/* My Address */}
            <TabsContent value="address">
              <Card>
                <CardHeader className="!p-4 !pb-0">
                  <h2 className="text-lg font-semibold">My Addresses</h2>
                </CardHeader>
                <CardContent className="!p-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {/* Add Address Card */}
                    <div
                      onClick={() => setOpen(true)}
                      className="border-2 border-dashed rounded-lg p-6 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-50"
                    >
                      <Plus size={28} className="text-gray-500" />
                      <span className="mt-2 text-gray-600 font-medium">
                        Add address
                      </span>
                    </div>

                    {/* Address Cards */}
                    {addresses.map((addr, idx) => (
                      <div key={idx} className="border rounded-lg p-4">
                        {addr.default && (
                          <div className="text-xs text-gray-500 mb-1">
                            <span className="font-bold text-gray-700">
                              Default
                            </span>
                          </div>
                        )}
                        <div className="font-medium mb-1">{addr.name}</div>
                        <div className="text-xs text-gray-800 mb-1">
                          {addr.address}
                          <br />
                          {addr.city}, {addr.state} {addr.zip}
                          <br />
                          {addr.country}
                        </div>
                        <div className="text-xs">Phone: {addr.phone}</div>
                        <div className="mt-2 flex items-center gap-2 text-xs text-blue-600">
                          <button>Edit</button>
                          <span>|</span>
                          <button>Remove</button>
                          {!addr.default && (
                            <>
                              <span>|</span>
                              <button>Set as Default</button>
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </CardContent>

                {/* Add Address Modal */}
                <Dialog open={open} onOpenChange={setOpen}>
                  <DialogContent className="max-w-[700px]">
                    <DialogHeader>
                      <DialogTitle>Add New Address</DialogTitle>
                    </DialogHeader>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <Label>Name</Label>
                        <Input placeholder="Full name" />
                      </div>
                      <div>
                        <Label>Phone Number</Label>
                        <Input placeholder="Phone number" />
                      </div>
                      <div>
                        <Label>City</Label>
                        <Input placeholder="City" />
                      </div>
                      <div>
                        <Label>State</Label>
                        <Input placeholder="State" />
                      </div>
                      <div>
                        <Label>ZIP Code</Label>
                        <Input placeholder="ZIP" />
                      </div>
                      <div>
                        <Label>Country</Label>
                        <Input placeholder="Country" />
                      </div>

                      {/* Address field at the last column, spanning full width */}
                      <div className="md:col-span-2">
                        <Label>Address</Label>
                        <Input placeholder="Street, building, etc." />
                      </div>
                    </div>

                    <DialogFooter>
                      <Button variant="outline" onClick={() => setOpen(false)}>
                        Cancel
                      </Button>
                      <Button onClick={() => setOpen(false)}>Save</Button>
                    </DialogFooter>
                  </DialogContent>
                </Dialog>
              </Card>
            </TabsContent>
          </div>
        </Tabs>
      </div>
      <Footer />
    </div>
  );
}
export default OrderPage;
